import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import InputText from 'components/inputs/InputText';
import { makeStyles } from '@material-ui/core/styles';
import {
    SELECTION_LIST_ITEM_MIN_HEIGHT,
    SPACING_LIST_NAME_WITH_ICON,
    SELECTION_LIST_ITEM_PADDING_LEFT_RIGHT,
    POPUP_PADDING_TOP_BOTTOM
} from 'const/style';
import Divider from 'components/divider/Base';
import DeleteSVG from 'assets/images/svg/DeleteSVG';
import { useDispatch } from 'react-redux';
import * as roleActions from '../actions/role';
import cloneDeep from 'lodash/cloneDeep';
import { isKbEscape, isKbEnter } from 'utils/keyboard';
import useClickAwaitListener from 'hooks/useClickAwaitListener';
import trim from 'lodash/trim';

const useStyles = makeStyles(theme => ({
    root: {
        width: 220
    },
    spacing: {},
    checkIcon: {
        fontSize: 14,
        color: theme.colors.white
    },
    settings: {
        '& a': {
            marginTop: 8,
            textDecoration: 'none',
            cursor: 'pointer',
            display: 'flex',
            height: SELECTION_LIST_ITEM_MIN_HEIGHT,
            paddingLeft: SELECTION_LIST_ITEM_PADDING_LEFT_RIGHT,
            paddingRight: SELECTION_LIST_ITEM_PADDING_LEFT_RIGHT,
            '&:hover': {
                background: theme.colors.hoverItem
            },
            '& svg': {
                fontSize: 20,
                color: theme.colors.midGrey,
                marginRight: SPACING_LIST_NAME_WITH_ICON,
                position: 'relative',
                top: 2
            }
        }
    },
    listItem: {
        marginTop: 8,
        cursor: 'pointer',
        display: 'flex',
        height: SELECTION_LIST_ITEM_MIN_HEIGHT,
        paddingLeft: SELECTION_LIST_ITEM_PADDING_LEFT_RIGHT,
        paddingRight: SELECTION_LIST_ITEM_PADDING_LEFT_RIGHT,
        '&:hover': {
            background: theme.colors.hoverItem
        },
        '& svg': {
            fontSize: 20,
            color: theme.colors.midGrey,
            marginRight: SPACING_LIST_NAME_WITH_ICON,
            position: 'relative',
            top: 2
        }
    },
    name: {
        padding: `0px ${POPUP_PADDING_TOP_BOTTOM}px`,
        marginBottom: 10
    },
    input: {
        backgroundColor: theme.colors.paleGrey,
        borderRadius: 4,
        '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
            border: 'none',
            '&:focus': {
                boxShadow: 'none'
            }
        }
    }
}));

function RolePoppup({ role, handleClickAway, onDeleteRole }) {
    const [roleName, setRoleName] = useState(role.name);
    const classes = useStyles();
    const dispatch = useDispatch();
    const rootRef = React.useRef();

    useClickAwaitListener(rootRef, e => {
        clickAwayHandler(e);
    });

    const clickAwayHandler = () => {
        if (trim(roleName) === '') {
            handleClickAway();
            return;
        }
        if (roleName === role.name) {
            handleClickAway();
            return;
        }

        dispatch(
            roleActions.updateRole({
                newRole: {
                    ...role,
                    name: roleName
                },
                oldRole: cloneDeep(role),
                successCallback: () => {
                    console.log('update role successfully');
                },
                errorCallback: () => {
                    console.log('failed to update role');
                }
            })
        );

        handleClickAway();
    };

    const handleKeyDown = e => {
        if (isKbEscape(e)) {
            handleClickAway();
            return;
        }
        if (!isKbEnter(e)) return;
        clickAwayHandler();
    };

    return (
        <Grid ref={rootRef} id={`grid_popup`} container direction="column" className={classes.root}>
            <Grid item className={classes.name}>
                <InputText
                    name="databaseName"
                    value={roleName}
                    onChange={e => setRoleName(e.target.value)}
                    placeholder="Role Name"
                    onKeyDown={handleKeyDown}
                    autoFocus
                    className={classes.input}
                    autoSelect={true}
                    inputProps={{
                        maxLength: 255
                    }}
                />
            </Grid>
            <Grid item>
                <Divider />
            </Grid>
            <Grid item className={`${classes.listItem}`} onClick={onDeleteRole}>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <DeleteSVG />
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">Delete</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default React.memo(RolePoppup);
